import { cn } from "@/lib/utils";

function Bar({ className }) {
  return <div className={cn("skeleton-shimmer rounded-md bg-secondary/60", className)} />;
}

export function SkeletonCard({ className }) {
  return (
    <div className={cn("rounded-2xl border border-border/60 bg-card/50 p-5", className)}>
      <Bar className="h-8 w-20" />
      <Bar className="mt-3 h-3 w-24" />
    </div>
  );
}

export function SkeletonKPIRow({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 6, cols = 6 }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-border/60 bg-card/40">
      <div className="border-b border-border/60 p-4">
        <Bar className="h-4 w-40" />
      </div>
      <div className="divide-y divide-border/50">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4 p-4">
            <Bar className="h-9 w-9 rounded-full" />
            {Array.from({ length: cols }).map((_, c) => (
              <Bar key={c} className="h-3 flex-1" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonMap({ className }) {
  return <Bar className={cn("h-full w-full rounded-2xl", className)} />;
}

export function SkeletonList({ rows = 4 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-xl border border-border/60 bg-card/40 p-4">
          <Bar className="h-10 w-10 rounded-lg" />
          <div className="flex-1 space-y-2">
            <Bar className="h-3 w-1/3" />
            <Bar className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
